module.exports = __webpack_public_path__ + "media/images/lb/225-038caa06c9c2b27f7cea950962b4f77a.svg";